import React from "react";
import { Outlet } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { endpoints } from "@/api";
import { useAuth } from "@/auth";
import Rail from "@/components/Rail";
import DemoBanner from "@/components/DemoBanner";

export default function Layout() {
  const { user } = useAuth();
  const { data: meta } = useQuery({ queryKey: ["meta"], queryFn: endpoints.meta });

  return (
    <div style={{ display: "flex", minHeight: "100vh", background: "var(--ui-bg)" }}>
      <Rail role={user?.role} counts={meta?.navCounts} sync={meta?.sync} />
      <main style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column" }}>
        {meta?.demoMode && <DemoBanner />}
        <div style={{ padding: "28px 30px", flex: 1 }} className="fade-in">
          <Outlet context={{ meta, user }} />
        </div>
      </main>
    </div>
  );
}
